import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { fetchCarDetails } from '../../redux/actions/carActions';
import './CarDetails.css';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faTwitter, faLinkedin, faWhatsapp, faInstagram } from '@fortawesome/free-brands-svg-icons';
import ModalImage from 'react-modal-image';

const CarDetails = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { car, loading, error } = useSelector((state) => state.carDetails || { car: null });

  useEffect(() => {
    if (id) {
      dispatch(fetchCarDetails(id));
    }
  }, [dispatch, id]);

  if (loading) return <p>Loading...</p>;
  if (error) return <p style={{ color: 'red' }}>Error: {error}</p>;
  if (!car) return <p>No car details available.</p>;

  const handleWhatsAppChat = () => {
    // Replace with the actual phone number (e.g., "1234567890" for a US number)
    const phoneNumber = "+254792454764"; // Target WhatsApp number
    const message = `Hello, I would like to enquire about this bike: ${car.make}, ${car.model}.`;
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

    window.open(url, '_blank'); // Open in a new tab
};

  return (
    <div className="car-details-container">
      <h2 className="car-title">{car.make} {car.model}</h2>

      <div className="car-image-section">
        <div className="carousel-container">
          <Carousel showThumbs={false} autoPlay infiniteLoop>
            {car.images && car.images.length > 0 ? (
              car.images.map((image, index) => (
                <div key={index}>
                  <img src={image} alt={`${car.make} ${car.model}`} className="carousel-image" />
                </div>
              ))
            ) : (
              <p>No images available</p>
            )}
          </Carousel>
        </div>

        <div className="car-price-container">
          <div className="finance-info">
            <p>Price: ksh{car.price}</p>
          </div>
          <div className="button-container">
            <div>
            <button className="action-button" onClick={handleWhatsAppChat}>
                Enquire via WhatsApp
            </button>
        </div>
            <button className="action-button">Arrange Callback</button>
          </div>
          {/* Social Media Share Buttons */}
          <div className="social-share">
            <h4>Share this car:</h4>
            <a href={`https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`} target="_blank" rel="noopener noreferrer" className="social-icon facebook">
              <FontAwesomeIcon icon={faFacebook} />
            </a>
            <a href={`https://twitter.com/intent/tweet?url=${window.location.href}`} target="_blank" rel="noopener noreferrer" className="social-icon twitter">
              <FontAwesomeIcon icon={faTwitter} />
            </a>
            <a href={`https://www.linkedin.com/shareArticle?url=${window.location.href}`} target="_blank" rel="noopener noreferrer" className="social-icon linkedin">
              <FontAwesomeIcon icon={faLinkedin} />
            </a>
            <a href={`https://api.whatsapp.com/send?text=${window.location.href}`} target="_blank" rel="noopener noreferrer" className="social-icon whatsapp">
              <FontAwesomeIcon icon={faWhatsapp} />
            </a>
            <a href="https://www.instagram.com/your_profile" target="_blank" rel="noopener noreferrer" className="social-icon instagram">
              <FontAwesomeIcon icon={faInstagram} />
            </a>
          </div>
        </div>
      </div>

      <div className="car-specifications-container">
        <h4>Specifications:</h4>
        <ul className="car-specifications">
          <li><strong>Year:</strong> {car.year}</li>
          <li><strong>Mileage:</strong> {car.mileage} miles</li>
          <li><strong>Engine Size:</strong> {car.engineSize} L</li>
          <li><strong>Transmission:</strong> {car.transmission}</li>
          <li><strong>Fuel Type:</strong> {car.fuelType}</li>
          <li><strong>Condition:</strong> {car.condition}</li>
          <li><strong>Location:</strong> {car.currentLocation}</li>
          <li><strong>Drive Train:</strong> {car.driveTrain}</li>
          <li><strong>Car description</strong></li>
          <div className="car-description">
            {car.description}
          </div>
        </ul>
      </div>

      <div className="car-images-list-container">
        <h4>Photos</h4>
        <div className="car-images-list">
          {car.images && car.images.length > 0 ? (
            car.images.map((image, index) => (
              <ModalImage
                key={index}
                small={image}
                large={image}
                alt={`${car.make} ${car.model}`}
                className="car-image-thumbnail"
              />
            ))
          ) : (
            <p>No images available</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default CarDetails;
